import api from "./api";
import { SITE_URL } from "./social";

let cached = null;
export const getInvite = async (fresh = false) => {
  if (!cached || fresh) cached = (await api.get("/referrals")).data;
  return cached;
};
export const inviteLink = (code) => (code ? `${SITE_URL}/?ref=${code}` : SITE_URL);

const REF_KEY = "gi_ref";
// Remember a friend's invite code from ?ref= until this visitor creates an account.
export function captureRef() {
  const url = new URL(window.location.href);
  const ref = (url.searchParams.get("ref") || "").toLowerCase();
  if (!/^[a-z0-9]{6,12}$/.test(ref)) return;
  localStorage.setItem(REF_KEY, ref);
  url.searchParams.delete("ref");
  window.history.replaceState(null, "", url.pathname + url.search + url.hash);
}
export function claimRef() {
  const ref = localStorage.getItem(REF_KEY);
  if (!ref) return;
  localStorage.removeItem(REF_KEY);
  api.post("/referrals/claim", { code: ref }).catch(() => {});
}
